import axios from 'axios';
import URLs from '../../utils/url';
import axiosClient from './apiClient';

let cancelToken: any;

export const fetchProduct = (url: string, type = 1) => {
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel('Operation canceled due to new request.');
  }

  cancelToken = axios.CancelToken.source();

  if (type === 1) {
    return axiosClient.get(`${URLs.apisV1}${url}`, { cancelToken: cancelToken.token });
  } else if (type === 2) {
    return axiosClient.get(`${URLs.apisV2}${url}`, { cancelToken: cancelToken.token });
  } else if (type === 3) {
    return axiosClient.get(`${URLs.apisV2}${url}`, { cancelToken: cancelToken.token });
  }
};

export const postProduct = (data: any, selectedShippingPriority?: string) => {
  /**
   * Send shipping priority to the API when its rush.
   */
  let shippingPriority = selectedShippingPriority === 'rush' ? `?shipping_priority=${selectedShippingPriority}` : '';
  return axiosClient.post(`${URLs.apisV2}${URLs.CREATE_PRODUCT}${shippingPriority}`, data);
};

export const getBestSellerById = (id: string, data: any) => {
  return axiosClient.post(`/v2/product/bestseller/${id}`, data);
};

export const getScreensaver = () => {
  const endpoint = 'admin/v1/getScreensaver';
  return axiosClient.get(endpoint, {
    headers: {
      subpath: 'helzberg'
    }
  });
};

export const getStoreData = (subpath = 'helzberg') => {
  return axiosClient.post('/admin/v1/builder-platform/status', { subpath });
};
